import sliderActions from './sliderActions';

export default {
  namespaced: true,
  state() {},
  getters: {},
  mutations: {},
  actions: sliderActions,
};
